import { ShareAltOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useState } from 'react';
import QuickShareModal from './QuickShareModal';

interface Props {
  phone: string | null | undefined;
  recipientName: string;
  message: string;
  title?: string;
  /** "link" suits a table cell; "default" suits a page header. */
  variant?: 'link' | 'default';
  label?: string;
}

/**
 * Drop-in "send this to the client" control. Owns its own modal state so a table column can use it
 * without every parent tracking which row is open.
 */
export default function QuickShareButton({
  phone,
  recipientName,
  message,
  title,
  variant = 'link',
  label = 'Send',
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Send via WhatsApp or SMS">
        <Button
          type={variant === 'link' ? 'link' : 'default'}
          size={variant === 'link' ? 'small' : 'middle'}
          icon={<ShareAltOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          {label}
        </Button>
      </Tooltip>

      <QuickShareModal
        open={open}
        onClose={() => setOpen(false)}
        phone={phone}
        recipientName={recipientName}
        defaultMessage={message}
        title={title}
      />
    </>
  );
}
